module.exports = __webpack_public_path__ + "img/categories.62270f5f.svg";